// extracted by mini-css-extract-plugin
export default {"ColorDecoratorMain":"color-decorator-module__ColorDecoratorMain--ZlwkC"};